module.exports = __webpack_public_path__ + "ff7763babd17052eca1a17230ed4e6a9.jpg";